export default __webpack_public_path__ + "static/media/emojis_blue.129f7b41.svg";